import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";

const AccordionStyled = styled(Accordion)`
  &::before {
    background-color: transparent;
  }

  &.Mui-expanded {
    margin-top: 0;
  }
`;

const AccordionDetailsStyled = styled(AccordionDetails)`
  flex-direction: column;
`;

const TextBlock = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

export const AddManuallyAdditionalInformation = () => {
  const { t } = useTranslation();
  const descriptions = [
    {
      id: 0,
      title: t("addManuallyPage.form.additionalInformation.interestTitle"),
      body: t("addManuallyPage.form.additionalInformation.interestBody"),
    },
    {
      id: 1,
      title: t("addManuallyPage.form.additionalInformation.otherGainsTitle"),
      body: t("addManuallyPage.form.additionalInformation.otherGainsBody"),
    },
    {
      id: 2,
      title: t("addManuallyPage.form.additionalInformation.taxRefundTitle"),
      body: t("addManuallyPage.form.additionalInformation.taxRefundBody"),
    },
  ];

  return (
    <AccordionStyled>
      <AccordionSummary
        data-testid="additional-information-summary"
        expandIcon={<ExpandMoreIcon />}
      >
        <Typography variant="h5">
          {t("addManuallyPage.form.additionalInformation.summary")}
        </Typography>
      </AccordionSummary>
      <Divider />
      <AccordionDetailsStyled>
        {descriptions.map(({ title, body, id }) => (
          <TextBlock key={id} data-testid="additional-information-hint">
            <Typography variant="h6">{title}</Typography>
            <Typography variant="body3">{body}</Typography>
          </TextBlock>
        ))}
      </AccordionDetailsStyled>
    </AccordionStyled>
  );
};
